<template>
  <section class="section pt-5">
    <div class="container">
      <!-- Encabezado -->
      <div class="level mb-5">
        <div class="level-left">
          <div class="level-item">
            <div>
              <h1 class="title">{{ $t("agent_management") }}</h1>
              <p class="subtitle">{{ $t("manage_helpdesk_agents") }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- DataTable de agentes -->
      <agents-datatable />
    </div>
  </section>
</template>

<script>
import AgentsDataTable from "./agents_datatable/Index.vue";

export default {
  name: "HelpdeskAgents",
  components: {
    "agents-datatable": AgentsDataTable,
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
}
</style>
